<template>
  <div class="countdown">
    距离今天活动倒计时：
    <div class="box">
      {{ h }}
    </div>
    时
    <div class="box">
      {{ m }}
    </div>
    分
    <div class="box">
      {{ s }}
    </div>
    秒
    <div class="box">
      {{ ms }}
    </div>
    毫秒
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'Countdown',

  data () {
    return {
      timeDiff: 0,
      interval: null,
      h: '',
      m: '',
      s: '',
      ms: ''
    }
  },

  mounted () {
    this.initInterval()
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    async initInterval () {
      const now = await this.getServiceTime()
      const todayEnd = new Date(now).setHours(23, 59, 59, 999)
      this.timeDiff = todayEnd - now
      this.interval = setInterval(() => {
        this.timeDiff -= 123
        if (this.timeDiff < 0) {
          this.timeDiff = 24 * 60 * 60 * 1000 + this.timeDiff
        }
        this.updateHms()
      }, 123)
    },

    getServiceTime () {
      return api.common.getServiceTime().then(res => res?.data?.timestamp * 1000)
    },

    updateHms () {
      const date = this.timeDiff
      const hours = parseInt(date / (1000 * 60 * 60))
      const minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = parseInt((date % (1000 * 60)) / 1000)
      const milliseconds = parseInt((date % (1000 * 60)) % 1000)
      this.h = hours < 10 ? ('0' + hours) : hours
      this.m = minutes < 10 ? ('0' + minutes) : minutes
      this.s = seconds < 10 ? ('0' + seconds) : seconds

      if (milliseconds < 10) {
        this.ms = '00' + milliseconds
      } else if (milliseconds < 100) {
        this.ms = '0' + milliseconds
      } else {
        this.ms = milliseconds
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.countdown { box-sizing: border-box; display: flex; align-items: center; justify-content: center; width: 458px; height: 31px; font-size: 12px; font-weight: 400; color: #fff; background: linear-gradient(90deg, #FF8236, #FF1818); border-radius: 6px;
  .box { box-sizing: border-box; display: flex; align-items: center; justify-content: center; width: 30px; height: 18px; margin: 0 2px; color: #FF9100; background-color: #fff; border: 1px solid #EECA82; border-radius: 4px; }
}

</style>
